import { render, staticRenderFns } from "./DriverFeesReportPrint.vue?vue&type=template&id=35b00ff0&scoped=true&"
import script from "./DriverFeesReportPrint.vue?vue&type=script&lang=js&"
export * from "./DriverFeesReportPrint.vue?vue&type=script&lang=js&"
import style0 from "./DriverFeesReportPrint.vue?vue&type=style&index=0&id=35b00ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b00ff0",
  null
  
)

export default component.exports